import React, { useRef } from "react";
import { Modal, Button } from "antd";
import {
  PrinterOutlined,
  FilePdfOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import oneBell from "../../../../assets/images/license/oneBell.png";
import oneMin from "../../../../assets/images/license/36.png";
import oneNoey from "../../../../assets/images/license/37.png";
import oneTome from "../../../../assets/images/license/oneTome.png";
// ─────────────────────────────────────────────────────────────────────────────
// Utilities
// ─────────────────────────────────────────────────────────────────────────────
const fmtMoney = (v) =>
  Number(v || 0).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtDate = (s) => {
  if (!s) return "-";
  const d = new Date(s);
  if (isNaN(d)) return "-";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

const SectionHeader = ({ children }) => (
  <div
    style={{
      background: "#1a3a5c",
      color: "#fff",
      fontWeight: 700,
      fontSize: 14,
      padding: "3px 8px",
      margin: "8px 0 4px",
      letterSpacing: 0.4,
    }}
  >
    {children}
  </div>
);

const LabelValue = ({ label, value, bold, color }) => (
  <div
    style={{
      display: "flex",
      fontSize: 12,
      padding: "1px 0",
      gap: 4,
      alignItems: "baseline",
    }}
  >
    <span style={{ color: "#555", whiteSpace: "nowrap", minWidth: 80 }}>
      {label}
    </span>
    <span
      style={{
        fontWeight: bold ? 700 : 400,
        color: color || "#222",
        wordBreak: "break-all",
      }}
    >
      {value ?? "-"}
    </span>
  </div>
);

const Row2 = ({ label, value }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      fontSize: 12,
      padding: "2px 0",
      borderBottom: "1px dashed #e0e8f0",
    }}
  >
    <span style={{ color: "#555" }}>{label}</span>
    <span style={{ fontWeight: 600, minWidth: 90, textAlign: "right" }}>
      {value}
    </span>
  </div>
);

function ProductTranferBody({
  dataDB2,
  billPayment,
  judgeData,
  lawsuitData,
  dataDefault,
  status,
}) {
  const company = billPayment?.company?.[1] || {};
  const pay = billPayment?.pay || [];
  const customer = dataDB2?.CUSTOMER || {};
  const address = customer?.ADDRESS?.[0] || {};
  const guarantors = dataDB2?.GUARANTORS || [];
  const mortgage = dataDB2?.MORTGAGE || {};
  const loan = dataDB2?.LOAN || {};
  const loanNew = judgeData?.loanNew || {};
  const T_NOPAY = Number(loanNew?.T_NOPAY || pay[0]?.T_NOPAY || 0);
  const fDate = new Date(loanNew?.FDATE || loan.FDATE);
  const dayOfMonth = isNaN(fDate) ? "05" : fDate.getDate();

  const newContno = loanNew?.NEW_CONTNO || pay[0]?.newContno || "-";
  const oldContno = loan.CONTNO || pay[0]?.CONTNO || "-";
  console.log("dataDefault", dataDefault);

  return (
    <div
      style={{
        fontFamily: "'Sarabun', 'TH Sarabun New', sans-serif",
        background: "#fff",
        color: "#111",
        padding: "10mm 10mm 10mm",
        fontSize: 12,
        lineHeight: 1.6,
        width: 794,
        maxWidth: 794,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* ── HEADER ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 6,
        }}
      >
        <div style={{ maxWidth: "55%" }}>
          <div style={{ fontWeight: 800, fontSize: 12, color: "#1a3a5c" }}>
            {company.COMP_NM || "-"}
          </div>

          <div style={{ fontSize: 12, color: "#444" }}>{company.COMP_ADR1}</div>
        </div>
        <div style={{ fontSize: 14, color: "#b3afaf", textAlign: "center" }}>
          [ บัญชี ]
        </div>
        <div style={{ textAlign: "right" }}>
          <div
            style={{
              border: "2.5px solid #1a3a5c",
              padding: "4px 18px",
              display: "inline-block",
              fontSize: 14,
              fontWeight: 900,
              color: "#1a3a5c",
              letterSpacing: 2,
              marginBottom: 4,
            }}
          >
            ใบขายสินค้า
          </div>
          <div style={{ fontSize: 12, color: "#555" }}>
            เลขที่ <strong>{newContno}</strong>
            <strong style={{ color: "#e74c3c" }}>
              {(dataDefault?.flagLoanNew === 2 || status === 2) &&
              dataDefault?.LAW_TYPE_ID === 6
                ? "(พิพากษาฟ้องส่วนต่าง)"
                : (dataDefault?.flagLoanNew === 2 || status === 2) &&
                    dataDefault?.LAW_TYPE_ID !== 6
                  ? "(พิพากษา)"
                  : (dataDefault?.flagLoanNew === 1 || status === 1) &&
                      dataDefault?.LAW_TYPE_ID === 6
                    ? "(ทำยอมฟ้องส่วนต่าง)"
                    : "(ทำยอม)"}
            </strong>
          </div>
          {console.log("loanNew", loanNew)}

          <div style={{ fontSize: 12, color: "#555" }}>
            วันที่ทำสัญญา{" "}
            <strong>
              {fmtDate(
                judgeData?.SDATE === "0001-01-01T00:00:00Z" || !judgeData?.SDATE
                  ? "-"
                  : judgeData?.SDATE,
              )}
            </strong>
          </div>
        </div>
      </div>

      <div style={{ borderTop: "2px solid #1a3a5c", marginBottom: 6 }} />

      {/* Contract ref row */}
      <div style={{ fontSize: 12, marginBottom: 4 }}>
        สถานที่ทำสัญญา: <strong>{company.COMP_ADR1}</strong>
      </div>

      {/* ── CUSTOMER ── */}
      <SectionHeader>รายละเอียดลูกค้า</SectionHeader>
      <div
        style={{
          paddingLeft: 8,
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "0 16px",
        }}
      >
        <LabelValue
          label="ชื่อลูกค้า"
          value={`${customer.SNAM || ""}${customer.NAME1 || ""} ${customer.NAME2 || ""}`}
          bold
        />
        <LabelValue label="เลขบัตรประชาชน" value={customer.CUSCOD} />
        <LabelValue
          label="ที่อยู่"
          value={`${address.ADDR1 || ""} ต.${address.TUMB || ""} อ.${address.AUMPDES || ""} จ.${address.PROVDES || ""} ${address.ZIP || ""}`}
        />
        <LabelValue label="อาชีพ" value={customer.OFFIC} />
        <LabelValue label="โทรศัพท์" value={address.TELP} />
        <LabelValue label="ที่ทำงาน" value={customer.OCCUP} />
      </div>

      {/* ── GUARANTORS ── */}
      {guarantors.length > 0 && (
        <>
          <SectionHeader>รายละเอียดผู้ค้าประกัน</SectionHeader>
          <div style={{ paddingLeft: 8 }}>
            {guarantors.map((g, i) => {
              const ga = g.ADDRESS?.[0] || {};
              return (
                <div
                  key={i}
                  style={{
                    marginBottom: 4,
                    paddingBottom: 4,
                    borderBottom:
                      i < guarantors.length - 1 ? "1px dashed #dce8ff" : "none",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: "0 16px",
                    }}
                  >
                    <LabelValue
                      label={`ชื่อผู้ค้า ${i + 1} (${g.RELATN || ""})`}
                      value={`${g.SNAM || ""}${g.NAME1 || ""} ${g.NAME2 || ""}`}
                      bold
                    />
                    <LabelValue label="เลขบัตรประชาชน" value={g.CUSCOD} />
                    {/* <LabelValue
                      label="ที่อยู่"
                      value={`${ga.ADDR1 || ""} ต.${ga.TUMB || ""} อ.${ga.AUMPDES || ""} จ.${ga.PROVDES || ""} ${ga.ZIP || ""}`}
                    />
                    <LabelValue label="อาชีพ" value={g.OFFIC} /> */}
                    <LabelValue label="โทรศัพท์" value={ga.TELP} />
                    {/* <LabelValue label="ที่ทำงาน" value={g.OCCUP} /> */}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* ── MORTGAGE ── */}
      <SectionHeader>รายละเอียดสินค้า</SectionHeader>
      <div
        style={{
          paddingLeft: 8,
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "0 16px",
        }}
      >
        <LabelValue
          label="ยี่ห้อ รุ่น"
          value={`${mortgage.TYPE || ""} ${mortgage.MODEL || ""}`}
          bold
        />
        <LabelValue label="แบบ" value={mortgage.BAAB} />
        <LabelValue label="สี" value={mortgage.COLOR} />
        <LabelValue
          label="ทะเบียน"
          value={`${mortgage.REGNO || "-"} ${mortgage.DORECV || ""}`}
          bold
        />
        <LabelValue label="ปีที่ผลิต" value={mortgage.MANUYR} />
        <LabelValue label="สถานะสินค้า" value="รถมือสอง" />
        <LabelValue label="เลขตัวถัง" value={mortgage.STRNO} />
        <LabelValue label="เลขเครื่อง" value={mortgage.ENGNO} />
      </div>

      {/* ── PAYMENT CONDITIONS + SALES INFO ── */}
      {loanNew?.NEW_CONTNO ? (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 0,
            marginTop: 6,
            border: "1px solid #ccd8ea",
          }}
        >
          {/* ── ซ้าย: เงื่อนไขการชำระเงิน ── */}
          <div style={{ borderRight: "1px solid #ccd8ea" }}>
            <SectionHeader>เงื่อนไขการชำระเงิน(ทำยอม)</SectionHeader>
            <div style={{ padding: "4px 8px", fontSize: 14 }}>
              {/* sub-header */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  fontWeight: 700,
                  borderBottom: "1px solid #ccd8ea",
                  paddingBottom: 2,
                  marginBottom: 3,
                }}
              >
                <span>รายการ</span>
                <span style={{ textAlign: "center" }}>วันถึงกำหนดชำระ</span>
                <span style={{ textAlign: "right" }}>จำนวนเงิน</span>
              </div>

              {/* งวดที่ 1 */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  padding: "2px 0",
                  borderBottom: "1px dashed #e0e8f0",
                }}
              >
                <span>งวดที่ 1 ถึง {T_NOPAY - 1}</span>
                <span style={{ textAlign: "center" }}>
                  {fmtDate(loanNew?.FDATE)}
                </span>
                <span style={{ textAlign: "right" }}>
                  {fmtMoney(loanNew?.TOT_UPAY * (T_NOPAY - 1))}
                </span>
              </div>

              {/* งวดที่ 2 ถึง N */}
              {/* <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  padding: "2px 0",
                  borderBottom: "1px dashed #e0e8f0",
                }}
              >
                <span>งวดที่ 2 ถึง {T_NOPAY - 1}</span>
                <span style={{ textAlign: "center", fontSize: 14 }}>
                  ทุกวันที่ {dayOfMonth} ของเดือนถัดไป
                </span>
                <span style={{ textAlign: "right" }}>
                  {fmtMoney(loanNew?.TOT_UPAY * (T_NOPAY - 2))}
                </span>
              </div> */}

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  padding: "2px 0",
                  borderBottom: "1px dashed #e0e8f0",
                }}
              >
                <span>งวดที่ {T_NOPAY}</span>
                <span style={{ textAlign: "center", fontSize: 14 }}>
                  {fmtDate(loanNew?.LDATE)}
                </span>
                <span style={{ textAlign: "right" }}>
                  {fmtMoney(
                    loanNew.LOAN_NEW_TONBALANCE -
                      loanNew?.TOT_UPAY * (T_NOPAY - 1),
                  )}
                </span>
              </div>

              {/* จ่ายทุก */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr ",
                  padding: "3px 0",
                  borderBottom: "1px dashed #e0e8f0",
                  fontSize: 14,
                }}
              >
                <span>
                  จ่ายงวดทุก 1 เดือน ทุกวันที่ {dayOfMonth} ของเดือนถัดไป
                </span>
                {/* <span>
                  วันที่งวดสุดท้าย <strong>{fmtDate(loanNew?.LDATE)}</strong>
                </span> */}
              </div>

              <div
                style={{
                  marginTop: 6,
                  borderTop: "1px solid #ccd8ea",
                  paddingTop: 4,
                }}
              >
                <Row2
                  label="ข้อมูลการขาย    ยอดจัด"
                  value={fmtMoney(loanNew?.NCSHPRC)}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 14,
                    padding: "2px 0",
                    borderBottom: "1px dashed #e0e8f0",
                  }}
                >
                  <span>
                    รีไฟแนนซ์ <strong>{loanNew?.ISSUNO || oldContno}</strong>
                  </span>
                  <span style={{ display: "flex", gap: 6 }}>
                    <strong style={{ textDecoration: "underline" }}>หัก</strong>
                    <span>ยอดปิด</span>
                    <span style={{ fontWeight: 600 }}>
                      {fmtMoney(loanNew?.NCSHPRC)}
                    </span>
                  </span>
                </div>
                <Row2
                  label={
                    <span>
                      <strong style={{ textDecoration: "underline" }}>
                        หัก
                      </strong>{" "}
                      ค่าจัด
                    </span>
                  }
                  value="0.00"
                />
                <Row2
                  label={
                    <span>
                      <strong style={{ textDecoration: "underline" }}>
                        หัก
                      </strong>{" "}
                      ค่าต่อทะเบียนและค่าใช้จ่ายอื่น
                    </span>
                  }
                  value="0.00"
                />
                {/* <Row2
                  label={
                    <span
                      style={{ fontWeight: 700, textDecoration: "underline" }}
                    >
                      ยอดจ่ายเช็ค
                    </span>
                  }
                  value="0.00"
                /> */}
              </div>
            </div>
          </div>

          {/* ── ขวา: รายละเอียดการขาย ── */}
          <div>
            <SectionHeader>รายละเอียดการขาย</SectionHeader>
            <div style={{ padding: "4px 8px" }}>
              <Row2
                label="(1) ราคาขายสด(ตัดจ่าย)"
                value={
                  <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                    {`${fmtMoney(judgeData?.creditDebtor)} บาท`}
                  </span>
                }
              />
              <Row2
                label="(2) เครดิตเปอร์เซ็น"
                value={`${fmtMoney(judgeData?.creditPercen)} %`}
              />
              <Row2
                label="(3) ดอกผล"
                value={`${fmtMoney(judgeData?.totalJugde - judgeData?.creditDebtor)} บาท`}
              />
              <Row2
                label="(4) ต้นทุนเก่า"
                value={`${fmtMoney(judgeData?.creditDebtorOld)} บาท`}
              />
              <div
                style={{
                  marginTop: 6,
                  borderTop: "1px solid #ccd8ea",
                  paddingTop: 4,
                }}
              >
                <Row2
                  label="ขายเช่าซื้อ (1)/(2):"
                  value={`${fmtMoney(judgeData.judgement)} บาท`}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <SectionHeader>รายละเอียดคำพิพากษา </SectionHeader>
          <div style={{ padding: "4px 8px" }}>
            <Row2
              label={`${billPayment.check8 !== "" ? `รีไฟแนนซ์ (${billPayment.check8})` : "รีไฟแนนซ์"}`}
              value={`${judgeData?.CONTNO}`}
            />
            <Row2
              label="(1) ราคาขายสด(ตัดจ่าย)"
              value={
                <span style={{ color: "#1890ff", fontWeight: "bold" }}>
                  {`${fmtMoney(judgeData?.creditDebtor)} บาท`}
                </span>
              }
            />
            <Row2
              label="(2) เครดิตเปอร์เซ็น"
              value={`${fmtMoney(judgeData?.creditPercen)} %`}
            />

            {/* <Row2
              label="(3) ดอกผล"
              value={`${fmtMoney(judgeData.totalJugde - judgeData?.creditDebtor)} บาท`}
            /> */}
            <Row2
              label={`(3) ต้นทุนเก่า`}
              value={`${fmtMoney(judgeData?.creditDebtorOld || 0)} บาท`}
            />
            <div
              style={{
                marginTop: 6,
                borderTop: "1px solid #ccd8ea",
                paddingTop: 4,
              }}
            >
              <Row2
                label="ขายเช่าซื้อ:"
                value={`${fmtMoney(judgeData.totalJugde)} บาท`}
              />
            </div>
          </div>
        </div>
      )}

      {/* ── SIGNATURES ── */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4,1fr)",
          gap: 10,
          marginTop: 16,
        }}
      >
        {[
          {
            label: "เบลอนุมัติ",
            signature: judgeData.checkJudge ? oneBell : null,
          },
          { label: `เฮียอนุมัติ`, signature: null },
          {
            label: `บัญชีอนุมัติ`,
            signature: judgeData.checkJudgeAccBy
              ? judgeData.checkJudgeAccBy === 36
                ? oneMin
                : oneNoey
              : null,
          },
          {
            label: "การเงินอนุมัติ",
            signature: judgeData.dateCheckJudgeFn ? oneTome : null,
          },
        ].map(({ label, signature }) => (
          <div
            key={label}
            style={{ textAlign: "center", fontSize: 14, paddingTop: 4 }}
          >
            <div
              style={{
                height: 48,
                margin: "0 10px 4px",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                position: "relative",
              }}
            >
              {/* รูปลายเซ็น (ถ้ามี) */}
              {signature && (
                <img
                  src={signature}
                  alt="signature"
                  style={{
                    position: "absolute",
                    bottom: 4,
                    height: 40,
                    objectFit: "contain",
                    opacity: 0.85,
                  }}
                />
              )}
              {/* เส้นประ */}
              <div
                style={{
                  borderBottom: "1px dotted #666",
                  width: "100%",
                }}
              />
            </div>
            <div style={{ color: "#444" }}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ProductTranfer({
  open,
  onClose,
  dataDB2,
  billPayment,
  judgeData,
  lawsuitData,
  dataDefault,
  status,
}) {
  const printRef = useRef();

  // ── Print ──────────────────────────────────────────────────────────────
  const handlePrint = () => {
    const content = printRef.current?.innerHTML || "";
    const win = window.open("", "_blank", "width=960,height=1200");
    win.document.write(`<!DOCTYPE html><html>
      <head>
      <meta charset="utf-8"/>
      <style>
        * { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:Sarabun,'TH Sarabun New',sans-serif; font-size:12px; background:#fff; }
        @page { size:A4; margin:0mm; }
        @media print { body { -webkit-print-color-adjust:exact; print-color-adjust:exact; } }
      </style>
    </head>
    <body>${content}</body>
  </html>`);
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
      win.close();
    }, 600);
  };

  // ── Export PDF ─────────────────────────────────────────────────────────
  const handleExportPDF = async () => {
    const loadScript = (src) =>
      new Promise((res, rej) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          res();
          return;
        }
        const s = document.createElement("script");
        s.src = src;
        s.onload = res;
        s.onerror = rej;
        document.head.appendChild(s);
      });

    try {
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js",
      );
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js",
      );

      const el = printRef.current;

      // ✅ บังคับ width ก่อน capture
      const savedScrollY = window.scrollY; // อ่านก่อน
      el.style.width = "794px";

      const canvas = await window.html2canvas(el, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        windowWidth: 794,
        width: 794,
        x: 0,
        scrollX: 0,
        scrollY: -savedScrollY,
      });

      // ✅ reset หลัง capture
      el.style.width = "";
      el.style.maxWidth = "";

      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pdfW = pdf.internal.pageSize.getWidth(); // 210mm
      const pageH = pdf.internal.pageSize.getHeight(); // 297mm
      const pdfH = (canvas.height * pdfW) / canvas.width;
      const imgData = canvas.toDataURL("image/jpeg", 0.97);

      let y = 0;
      while (y < pdfH) {
        if (y > 0) pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, -y, pdfW, pdfH);
        y += pageH;
      }

      const newContno =
        judgeData?.loanNew?.NEW_CONTNO ||
        billPayment?.pay?.[0]?.newContno ||
        "delivery";
      pdf.save(`ใบขายสินค้า_${newContno}.pdf`);
    } catch (err) {
      console.error("PDF export error:", err);
    }
  };

  const handleExportJPEG = async () => {
    const loadScript = (src) =>
      new Promise((res, rej) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          res();
          return;
        }
        const s = document.createElement("script");
        s.src = src;
        s.onload = res;
        s.onerror = rej;
        document.head.appendChild(s);
      });

    try {
      await loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js",
      );

      const el = printRef.current;
      const savedScrollY = window.scrollY;
      el.style.width = "794px";

      const canvas = await window.html2canvas(el, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        windowWidth: 794,
        width: 794,
        x: 0,
        scrollX: 0,
        scrollY: -savedScrollY,
      });

      el.style.width = "";

      // ✅ แปลง canvas → blob แล้ว download
      canvas.toBlob(
        (blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          const contno =
            judgeData?.loanNew?.NEW_CONTNO ||
            billPayment?.pay?.[0]?.newContno ||
            dataDB2?.LOAN?.CONTNO || // ✅ ใช้ CONTNO
            "delivery";
          a.href = url;
          a.download = `ใบขายสินค้า_${contno}.jpeg`;
          a.click();
          URL.revokeObjectURL(url);
        },
        "image/jpeg",
        0.97, // quality
      );
    } catch (err) {
      console.error("JPEG export error:", err);
    }
  };

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@400;600;700;800&display=swap');`}</style>
      <Modal
        open={open}
        onCancel={onClose}
        width={840}
        title="📦 ใบขายสินค้า (Delivery Note)"
        destroyOnHidden
        styles={{
          body: {
            maxHeight: "78vh",
            overflowY: "auto",
            padding: "8px 0",
            background: "#f0f4fa",
          },
        }}
        footer={[
          <Button key="close" onClick={onClose}>
            ปิด
          </Button>,
          <Button key="print" icon={<PrinterOutlined />} onClick={handlePrint}>
            พิมพ์
          </Button>,
          <Button
            key="jpeg"
            icon={<FileImageOutlined />}
            onClick={handleExportJPEG}
            type="primary"
          >
            ดาวน์โหลด JPEG
          </Button>,
          <Button
            key="pdf"
            type="primary"
            icon={<FilePdfOutlined />}
            onClick={handleExportPDF}
            style={{ background: "#c0392b", borderColor: "#c0392b" }}
          >
            ดาวน์โหลด PDF
          </Button>,
        ]}
      >
        <div ref={printRef} style={{ width: 794, overflow: "hidden" }}>
          <ProductTranferBody
            dataDB2={dataDB2}
            billPayment={billPayment}
            judgeData={judgeData}
            lawsuitData={lawsuitData}
            dataDefault={dataDefault}
            status={status}
          />
        </div>
      </Modal>
    </>
  );
}
